<template>
  <div class="dialog-host">
    <v-dialog
      v-model="showD"
      :max-width="smAndDown ? '96%' : dialogSize"
      max-height="90%"
      transition="custom-from-bottom-transition"
      scrollable
      persistent
      class="dialog-surface"
    >
      <v-card class="card-body w-100 dialog-surface dialog-card">
        <v-card-title
          class="card-header-text card-header text-h6 text-sm-h6 text-md-h5 font-weight-bold dialog-title"
          >{{ titleText }}</v-card-title
        >

        <v-card-text
          v-if="insertText != 'not-used'"
          class="font-weight-bold text-h6 dialog-copy dialog-copy--lead"
          >{{ insertText }}</v-card-text
        >
        <v-card-text
          v-if="explanationText != 'not-used'"
          class="font-italic font-weight-regular text-subtitle-1 text-sm-h6 text-md-h6 dialog-copy dialog-copy--support"
          >{{ explanationText }}</v-card-text
        >

        <v-card-text class="text-subtitle-1 text-sm-h6 text-md-h6 w-100 dialog-body"
          ><slot name="dSlot" class="w-100"> </slot
        ></v-card-text>

        <v-card-actions class="dialog-actions ma-0">
          <v-spacer></v-spacer>
          <v-btn
            v-if="leftBtnText != 'not-used'"
            type="button"
            @click.stop.prevent="handleLeftButton"
            class="elevation-2 stdBtn stdBtn--action mr-4"
            :size="smAndDown ? 'x-small' : 'small'"
            :disabled="leftBtnDisabled"
            >{{ leftBtnText }}</v-btn
          >

          <v-btn
            v-if="rightBtnText != 'not-used'"
            type="button"
            @click.stop.prevent="handleRightButton"
            class="elevation-2 stdBtn stdBtn--action ml-0"
            :size="smAndDown ? 'x-small' : 'small'"
            :disabled="rightBtnDisabled"
            >{{ rightBtnText }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
  import { ref, watch } from "vue";
  import { useDisplay } from "vuetify";

  //Load reactive true or false for small and down display size
  let { smAndDown } = useDisplay();

  const props = defineProps({
    showDialog: {
      type: Boolean,
      required: true,
    },
    titleText: {
      type: String,
      required: true,
    },
    insertText: {
      type: String,
      required: true,
    },
    explanationText: {
      type: String,
      required: true,
    },
    leftBtnText: {
      type: String,
      required: true,
    },
    leftBtnDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    rightBtnText: {
      type: String,
      required: true,
    },
    rightBtnDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeOnLeftBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
    closeOnRightBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
    dialogWidth: {
      type: String,
      required: false,
      default: "medium",
    },
  });

  const emit = defineEmits(["leftBtn", "rightBtn", "left-btn", "right-btn"]);

  let dialogSize = ref("");
  if (props.dialogWidth === "large") {
    dialogSize.value = "min(96vw, var(--cssDialogMaxWidth-lg))";
  } else if (props.dialogWidth === "medium") {
    dialogSize.value = "min(92vw, var(--cssDialogMaxWidth-md))";
  } else if (props.dialogWidth === "small") {
    dialogSize.value = "min(90vw, var(--cssDialogMaxWidth-sm))";
  }

  let showD = ref(props.showDialog);

  watch(
    () => props.showDialog,
    (newVal) => {
      showD.value = newVal;
    }
  );

  function handleLeftButton() {
    if (props.closeOnLeftBtn) {
      showD.value = false;
    }
    emit("leftBtn");
    emit("left-btn");
  }

  function handleRightButton() {
    if (props.closeOnRightBtn) {
      showD.value = false;
    }
    emit("rightBtn");
    emit("right-btn");
  }
</script>

<style lang="scss"></style>
